// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ArticlePagingResultModel from '../../model/article-paging-result-model';
import ArticlePagingResultDTO from '../dto/article-paging-result-dto';
import dtoSchema from '../schemas/article-paging-result-schema';
import ArticleModel from '../../model/article-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class ArticlePagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ArticlePagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ArticleModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: ArticleModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<ArticlePagingResultDTO>): ArticlePagingResultModel;
  static toModel(dto: DeepPartial<ArticlePagingResultDTO> | undefined | null): ArticlePagingResultModel | undefined;
  static toModel(dto: DeepPartial<ArticlePagingResultDTO> | undefined | null): ArticlePagingResultModel | undefined {
    return dto ? new ArticlePagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ArticlePagingResultModel> | ArticlePagingResultModel): ArticlePagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as ArticlePagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ArticlePagingResultModel, can not map to ArticlePagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
